// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivateCasePopup_content_container__2VyFi {
  padding: 5px;
}

.ActivateCasePopup_activate_hr__PE-hF {
  height: 1px;
  border: none;
  background-color: var(--color-theme-silver);
  margin: 15px 0px;
  width: 100%;
}

.ActivateCasePopup_price_row__bCldw {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.ActivateCasePopup_price_container__a4\\+TO {
  width: 170px;
  padding-left: 15px;
}
.ActivateCasePopup_price_label__XXU\\+m {
  font-size: 12px;
}

.ActivateCasePopup_price_value__XtC68 {
  font-size: 20px;
  padding-top: 3px;
  overflow-wrap: break-word;
}

.ActivateCasePopup_total_container__6ViKH {
  margin: 15px 0px;
  padding: 15px;
  background-color: var(--color-theme-snow);
}

.ActivateCasePopup_total_label__-Fopp {
  font-size: 12px;
}

.ActivateCasePopup_total_value__fbm4B {
  font-size: 20px;
  font-weight: bold;
}

.ActivateCasePopup_btn_additional_fees__0NXHF {
  flex: 2 1;
  font-weight: 600 !important;
  color: var(--color-theme-10) !important;
  height: 40px;
  max-width: 300px !important;
  line-height: 0px !important;
}

.ActivateCasePopup_findings_container__MBGfx {
  display: block;
}

.ActivateCasePopup_finding_container__YrCl6 {
  display: flex;
  align-items: flex-start;
}

.ActivateCasePopup_finging_image_container__cAPp8 {
  width: 70px;
}

.ActivateCasePopup_finging_image__SgKqA {
  height: 55px;
  padding-top: 15px;
  padding-left: 5px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
}

.ActivateCasePopup_finging_details_container__n1h9z {
  width: 280px;
  padding: 6px 20px;
}

.ActivateCasePopup_finding_id__\\+TRHJ {
  font-size: 12px;
  max-width: 200px;
  overflow-x: scroll;
}

.ActivateCasePopup_finding_link__A-NR7 {
  text-decoration: none;
  color: var(--color-font-10);
}

.ActivateCasePopup_finging_price_container__7MlPQ {
  width: 120px;
  padding-top: 15px;
}

.ActivateCasePopup_currency__1vb8w {
  font-size: 16px;
}

.ActivateCasePopup_error_container__5HeT4 {
  padding: 10px;
  margin: 0px 5px 25px 5px;
  background-color: var(--color-theme-red);
}

.ActivateCasePopup_error_text__ruJDb {
  font-size: 16px;
  color: var(--color-theme-white);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ActivateCasePopup/ActivateCasePopup.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".content_container {\n  padding: 5px;\n}\n\n.activate_hr {\n  height: 1px;\n  border: none;\n  background-color: var(--color-theme-silver);\n  margin: 15px 0px;\n  width: 100%;\n}\n\n.price_row {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 10px;\n}\n\n.price_container {\n  width: 170px;\n  padding-left: 15px;\n}\n.price_label {\n  font-size: 12px;\n}\n\n.price_value {\n  font-size: 20px;\n  padding-top: 3px;\n  overflow-wrap: break-word;\n}\n\n.total_container {\n  margin: 15px 0px;\n  padding: 15px;\n  background-color: var(--color-theme-snow);\n}\n\n.total_label {\n  font-size: 12px;\n}\n\n.total_value {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.btn_additional_fees {\n  flex: 2;\n  font-weight: 600 !important;\n  color: var(--color-theme-10) !important;\n  height: 40px;\n  max-width: 300px !important;\n  line-height: 0px !important;\n}\n\n.findings_container {\n  display: block;\n}\n\n.finding_container {\n  display: flex;\n  align-items: flex-start;\n}\n\n.finging_image_container {\n  width: 70px;\n}\n\n.finging_image {\n  height: 55px;\n  padding-top: 15px;\n  padding-left: 5px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n}\n\n.finging_details_container {\n  width: 280px;\n  padding: 6px 20px;\n}\n\n.finding_id {\n  font-size: 12px;\n  max-width: 200px;\n  overflow-x: scroll;\n}\n\n.finding_link {\n  text-decoration: none;\n  color: var(--color-font-10);\n}\n\n.finging_price_container {\n  width: 120px;\n  padding-top: 15px;\n}\n\n.currency {\n  font-size: 16px;\n}\n\n.error_container {\n  padding: 10px;\n  margin: 0px 5px 25px 5px;\n  background-color: var(--color-theme-red);\n}\n\n.error_text {\n  font-size: 16px;\n  color: var(--color-theme-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `ActivateCasePopup_content_container__2VyFi`,
	"activate_hr": `ActivateCasePopup_activate_hr__PE-hF`,
	"price_row": `ActivateCasePopup_price_row__bCldw`,
	"price_container": `ActivateCasePopup_price_container__a4+TO`,
	"price_label": `ActivateCasePopup_price_label__XXU+m`,
	"price_value": `ActivateCasePopup_price_value__XtC68`,
	"total_container": `ActivateCasePopup_total_container__6ViKH`,
	"total_label": `ActivateCasePopup_total_label__-Fopp`,
	"total_value": `ActivateCasePopup_total_value__fbm4B`,
	"btn_additional_fees": `ActivateCasePopup_btn_additional_fees__0NXHF`,
	"findings_container": `ActivateCasePopup_findings_container__MBGfx`,
	"finding_container": `ActivateCasePopup_finding_container__YrCl6`,
	"finging_image_container": `ActivateCasePopup_finging_image_container__cAPp8`,
	"finging_image": `ActivateCasePopup_finging_image__SgKqA`,
	"finging_details_container": `ActivateCasePopup_finging_details_container__n1h9z`,
	"finding_id": `ActivateCasePopup_finding_id__+TRHJ`,
	"finding_link": `ActivateCasePopup_finding_link__A-NR7`,
	"finging_price_container": `ActivateCasePopup_finging_price_container__7MlPQ`,
	"currency": `ActivateCasePopup_currency__1vb8w`,
	"error_container": `ActivateCasePopup_error_container__5HeT4`,
	"error_text": `ActivateCasePopup_error_text__ruJDb`
};
export default ___CSS_LOADER_EXPORT___;
